import { MessageId } from '@/models/Message';
import { mkTrackAttrs } from '@/analytics/track';
import { UserId } from '@/models/User';

const PREFIX = 'msg';

// Message
export const mkMessageTrackAttrs = (props: { messageId: MessageId }) =>
  mkTrackAttrs(`${PREFIX}__message`, props);

// Timestamp
export const mkTimestampTrackAttrs = (props: { messageId: MessageId }) =>
  mkTrackAttrs(`${PREFIX}__timestamp`, props);

// Tool Calls
export const mkToolCallsBtnTrackAttrs = (props: { messageId: MessageId }) =>
  mkTrackAttrs(`${PREFIX}__tool_calls_btn`, props);

// User Image
export const mkUserImgTrackAttrs = (props: {
  messageId: MessageId;
  userId: UserId;
}) => mkTrackAttrs(`${PREFIX}__user_img`, props);

// User Name
export const mkUserNameTrackAttrs = (props: {
  messageId: MessageId;
  userId: UserId;
}) => mkTrackAttrs(`${PREFIX}__user_name`, props);
